import { createSlice } from "@reduxjs/toolkit";
import { getFoodDrinks, getWallpapers } from "./thunk";

export interface IState {
  foodDrinks: any;
  isFoodDrinkLoading: boolean;
  isFoodDrinkSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  foodDrinks: null,
  isFoodDrinkLoading: false,
  isFoodDrinkSuccess: false,

  error: {},
};

const FoodDrinkSlice = createSlice({
  name: "FoodDrink",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get FoodDrinks
    builder.addCase(getFoodDrinks.pending, (state: IState, action: any) => {
      state.isFoodDrinkLoading = true;
    });
    builder.addCase(getFoodDrinks.fulfilled, (state: IState, action: any) => {
      state.foodDrinks = action.payload.data;
      state.isFoodDrinkSuccess = true;
      state.isFoodDrinkLoading = false;
    });
    builder.addCase(getFoodDrinks.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isFoodDrinkSuccess = false;
      state.isFoodDrinkLoading = false;
    });
  },
});

const WallpaperSlice = createSlice({
  name: "Wallpaper",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get FoodDrinks
    builder.addCase(getWallpapers.pending, (state: IState, action: any) => {
      state.isFoodDrinkLoading = true;
    });
    builder.addCase(getWallpapers.fulfilled, (state: IState, action: any) => {
      state.foodDrinks = action.payload.data;
      state.isFoodDrinkSuccess = true;
      state.isFoodDrinkLoading = false;
    });
    builder.addCase(getWallpapers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isFoodDrinkSuccess = false;
      state.isFoodDrinkLoading = false;
    });
  },
});

export const FoodDrinkReducer = FoodDrinkSlice.reducer;
export const WallpaperReducer = WallpaperSlice.reducer;